/**
 * Replace all occurrences of a string with another string
 * @param inputString - The string to modify
 * @param modifications - An object containing the string to replace as the key and the string to replace it with as the value
 */

export const modifyStringReplaceAll = (
    inputString: string,
    modifications: Record<string, string>
) => {
    let modifiedString = inputString;

    Object.entries(modifications).forEach(([key, value]) => {
        const regex = new RegExp(key, 'g');
        modifiedString = modifiedString.replace(regex, value);
    });

    return modifiedString;
};

/**
 * Remove all special characters from a string
 * @param inputString - The string to modify
 * @param exceptions - An array of characters to exclude from the removal
 */
export const removeSpecialCharacters = (
    inputString: string,
    exceptions: string[] = []
) => {
    const allowedChars = exceptions.join('');
    const regexPattern = `[^A-Za-z0-9${allowedChars.replace(
        /[-\\^$*+?.()|[\]{}]/g,
        '\\$&'
    )}]`;
    const regex = new RegExp(regexPattern, 'g');

    return inputString.replace(regex, '');
};

/**
 * Converts string to Title Case
 *
 * @param str - The string to modify
 */
export const toTitleCase = (str: string) =>
    str.replace(
        /\w\S*/g,
        txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
